import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "mt-1 mb-0" }
const _hoisted_2 = { class: "text-body-2 text-grey-darken-1 mb-3" }
const _hoisted_3 = {
  key: 1,
  class: "bg-grey-lighten-5 border rounded-lg pa-4 mb-4"
}
const _hoisted_4 = { class: "flex justify-between py-1 px-2" }
const _hoisted_5 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_6 = { class: "flex justify-between py-1 px-2" }
const _hoisted_7 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_8 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_9 = { class: "px-2 py-0" }
const _hoisted_10 = { class: "text-caption text-grey font-italic" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex justify-between py-1 px-2" }
const _hoisted_13 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_14 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_15 = { class: "flex justify-between py-1 px-2" }
const _hoisted_16 = {
  class: "text-body-1 font-weight-bold text-green-darken-2",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_17 = {
  class: "flex justify-between py-1 px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_18 = {
  class: "text-caption font-weight-medium",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_19 = { class: "flex justify-between py-1 px-2" }
const _hoisted_20 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_21 = { class: "flex justify-between py-1 px-2" }
const _hoisted_22 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_23 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_24 = { class: "flex justify-between py-1 px-2 border-t font-weight-bold mt-1 pt-2" }
const _hoisted_25 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_26 = { class: "flex justify-between py-1 px-2" }
const _hoisted_27 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_28 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_29 = { class: "px-2 py-0" }
const _hoisted_30 = { class: "text-caption text-grey font-italic" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "flex justify-between py-1 px-2" }
const _hoisted_33 = {
  class: "text-body-1 font-weight-bold text-green-darken-2",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_34 = {
  class: "flex justify-between py-1 px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_35 = {
  class: "text-caption font-weight-medium",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_36 = { class: "flex justify-between py-1 px-2" }
const _hoisted_37 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_38 = { class: "flex justify-between py-1 px-2" }
const _hoisted_39 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_40 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_41 = { class: "px-2 py-0" }
const _hoisted_42 = { class: "text-caption text-grey font-italic" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { class: "flex justify-between py-1 px-2" }
const _hoisted_45 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_46 = { class: "flex justify-between py-1 px-2 border-t font-weight-bold mt-1 pt-2" }
const _hoisted_47 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_48 = { class: "flex justify-between py-1 px-2" }
const _hoisted_49 = {
  class: "text-body-1 font-weight-bold text-green-darken-2",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_50 = {
  class: "flex justify-between py-1 px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_51 = {
  class: "text-caption font-weight-medium",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_52 = { class: "flex justify-between py-1 px-2" }
const _hoisted_53 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_54 = { class: "flex justify-between py-1 px-2" }
const _hoisted_55 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_56 = { class: "flex justify-between py-1 px-2 border-t font-weight-bold mt-1 pt-2" }
const _hoisted_57 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_58 = { class: "flex justify-between py-1 px-2" }
const _hoisted_59 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_60 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_61 = { class: "px-2 py-0" }
const _hoisted_62 = { class: "text-caption text-grey font-italic" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "flex justify-between py-1 px-2" }
const _hoisted_65 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_66 = { class: "flex justify-between py-1 px-2 border-t font-weight-bold mt-1 pt-2" }
const _hoisted_67 = {
  class: "text-body-2 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_68 = { class: "flex justify-between py-1 px-2" }
const _hoisted_69 = {
  class: "text-body-1 font-weight-bold text-green-darken-2",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_70 = {
  class: "flex justify-between py-1 px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_71 = {
  class: "text-caption font-weight-medium",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_72 = { class: "flex items-center gap-4 mb-4 flex-wrap" }
const _hoisted_73 = { class: "border-2 border-green rounded-lg pa-4 bg-green-lighten-5 flex justify-between items-center gap-4 flex-grow-1" }
const _hoisted_74 = { class: "text-h5 font-weight-bold text-green-darken-3" }
const _hoisted_75 = {
  key: 0,
  class: "text-caption text-green-darken-2 font-weight-medium"
}
const _hoisted_76 = {
  key: 1,
  class: "text-caption text-orange-darken-2 font-weight-medium"
}
const _hoisted_77 = {
  key: 2,
  class: "text-caption text-amber-darken-2 font-weight-medium"
}
const _hoisted_78 = {
  key: 2,
  class: "mb-4 flex gap-3 items-end flex-wrap"
}
const _hoisted_79 = {
  class: "flex-grow-1",
  style: {"min-width":"180px","flex-basis":"190px"}
}
const _hoisted_80 = { class: "text-uppercase text-caption font-weight-bold text-grey-darken-1 mb-1" }
const _hoisted_81 = { style: {"width":"170px","flex-shrink":"0"} }
const _hoisted_82 = { class: "text-uppercase text-caption font-weight-bold text-grey-darken-1 mb-1" }
const _hoisted_83 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_84 = { class: "mb-4" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = { class: "flex items-center gap-3" }
const _hoisted_87 = { class: "text-body-2 font-weight-medium" }
const _hoisted_88 = { class: "text-caption text-grey" }
const _hoisted_89 = {
  class: "text-body-1 font-weight-bold",
  style: {"font-variant-numeric":"tabular-nums"}
}
const _hoisted_90 = {
  key: 1,
  class: "border border-dashed rounded-lg pa-3 text-center text-caption text-grey"
}
const _hoisted_91 = { class: "mt-1 mb-0" }
const _hoisted_92 = { class: "flex items-center justify-between gap-[14px] py-4 px-[18px] bg-[#f1faf4] border border-[#bfe0c6] rounded-[10px] mb-4" }
const _hoisted_93 = { class: "fee-callout-amount text-[26px] font-bold text-[#1b5e20] tabular-nums leading-none" }
const _hoisted_94 = { class: "fee-calc-section mb-4" }
const _hoisted_95 = { class: "text-body-2 text-grey-darken-1 mb-3" }
const _hoisted_96 = {
  key: 0,
  class: "bg-[#f7f7f7] border border-[#e5e5e5] rounded-lg p-4 text-[13px]"
}
const _hoisted_97 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_98 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_99 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_100 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_101 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_102 = { class: "px-2 pb-1" }
const _hoisted_103 = { class: "text-caption text-grey font-italic" }
const _hoisted_104 = { key: 0 }
const _hoisted_105 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_106 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_107 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_108 = { class: "flex justify-between py-[5px] px-2 border-t-2 border-t-[#424242] mt-1.5 pt-2 font-bold text-[#24ab10] text-[15px]" }
const _hoisted_109 = { class: "font-semibold tabular-nums" }
const _hoisted_110 = {
  class: "flex justify-between py-[5px] px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_111 = { class: "text-caption font-weight-medium tabular-nums" }
const _hoisted_112 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_113 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_114 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_115 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_116 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_117 = { class: "flex justify-between py-[5px] px-2 border-t mt-1 pt-2" }
const _hoisted_118 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_119 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_120 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_121 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_122 = { class: "px-2 pb-1" }
const _hoisted_123 = { class: "text-caption text-grey font-italic" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { class: "flex justify-between py-[5px] px-2 border-t-2 border-t-[#424242] mt-1.5 pt-2 font-bold text-[#24ab10] text-[15px]" }
const _hoisted_126 = { class: "font-semibold tabular-nums" }
const _hoisted_127 = {
  class: "flex justify-between py-[5px] px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_128 = { class: "text-caption font-weight-medium tabular-nums" }
const _hoisted_129 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_130 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_131 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_132 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_133 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_134 = { class: "px-2 pb-1" }
const _hoisted_135 = { class: "text-caption text-grey font-italic" }
const _hoisted_136 = { key: 0 }
const _hoisted_137 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_138 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_139 = { class: "flex justify-between py-[5px] px-2 border-t mt-1 pt-2" }
const _hoisted_140 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_141 = { class: "flex justify-between py-[5px] px-2 border-t-2 border-t-[#424242] mt-1.5 pt-2 font-bold text-[#24ab10] text-[15px]" }
const _hoisted_142 = { class: "font-semibold tabular-nums" }
const _hoisted_143 = {
  class: "flex justify-between py-[5px] px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_144 = { class: "text-caption font-weight-medium tabular-nums" }
const _hoisted_145 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_146 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_147 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_148 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_149 = { class: "flex justify-between py-[5px] px-2 border-t mt-1 pt-2" }
const _hoisted_150 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_151 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_152 = { class: "text-body-2 text-grey-darken-2" }
const _hoisted_153 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_154 = { class: "px-2 pb-1" }
const _hoisted_155 = { class: "text-caption text-grey font-italic" }
const _hoisted_156 = { key: 0 }
const _hoisted_157 = { class: "flex justify-between py-[5px] px-2" }
const _hoisted_158 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_159 = { class: "flex justify-between py-[5px] px-2 border-t mt-1 pt-2" }
const _hoisted_160 = { class: "text-body-2 font-weight-bold tabular-nums" }
const _hoisted_161 = { class: "flex justify-between py-[5px] px-2 border-t-2 border-t-[#424242] mt-1.5 pt-2 font-bold text-[#24ab10] text-[15px]" }
const _hoisted_162 = { class: "font-semibold tabular-nums" }
const _hoisted_163 = {
  class: "flex justify-between py-[5px] px-2",
  style: {"opacity":"0.6"}
}
const _hoisted_164 = { class: "text-caption font-weight-medium tabular-nums" }
const _hoisted_165 = {
  class: "fee-edit-details mb-4",
  open: ""
}
const _hoisted_166 = { class: "pt-3 pb-1" }
const _hoisted_167 = { class: "d-flex gap-3 flex-wrap align-end" }
const _hoisted_168 = {
  class: "flex-grow-1",
  style: {"min-width":"180px"}
}
const _hoisted_169 = { class: "text-uppercase text-caption font-weight-bold text-grey-darken-1 mb-1" }
const _hoisted_170 = { style: {"width":"170px","flex-shrink":"0"} }
const _hoisted_171 = { class: "text-uppercase text-caption font-weight-bold text-grey-darken-1 mb-1" }
const _hoisted_172 = { class: "pb-1" }
const _hoisted_173 = {
  key: 4,
  class: "fee-recipients-details mb-4 bg-[#f1faf4] border border-[#bfe0c6] rounded-[10px] px-[18px] py-3",
  open: ""
}
const _hoisted_174 = { class: "flex items-center gap-[5px] text-[12.5px] font-semibold text-[#1b5e20] cursor-pointer select-none list-none py-[5px] border-b border-b-[#8ec8a0] pb-[8px]" }
const _hoisted_175 = { class: "co-counsel-recipients-section pt-2 text-[13px]" }
const _hoisted_176 = {
  key: 0,
  class: "text-caption text-grey ml-1"
}
const _hoisted_177 = { class: "flex items-center gap-3" }
const _hoisted_178 = {
  key: 0,
  style: {"width":"130px"}
}
const _hoisted_179 = { key: 1 }
const _hoisted_180 = {
  class: "font-weight-bold",
  style: {"min-width":"90px","text-align":"right"}
}
const _hoisted_181 = {
  key: 3,
  class: "sett-step-footer"
}
const _hoisted_182 = {
  key: 4,
  class: "sett-step-footer"
}

import { computed, ref, watch } from 'vue';
import { format, isValid, parseISO } from 'date-fns';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlDatePicker from '@/components/LlDatePicker.vue';
import LlTooltip from '@/components/LlTooltip.vue';
import LlIcon from '@/components/LlIcon.vue';
import AlertBar from '@/components/AlertBar.vue';
import { formatCurrency } from '@/services/utils';
import type { FeeRecipientRole, FeeRecipient } from '@/models/settlementTypes';
import { roleLabel } from '@/utils/roleLabels';

interface FeeBreakdownSummary {
  recoveryAmount?: number | null;
  attorneyFee?: number | null;
  unreimbursedExpenses?: number | null;
  totalExpenses?: number | null;
  alreadyPaidByClient?: number | null;
  feeBase?: number | null;
  netAttorneyFee?: number | null;
  clientNetRecovery?: number | null;
  generatingFirmRetainedAmount?: number | null;
  generatingFirmRetainedPercentage?: number | null;
}

interface FeeBreakdown {
  variant: string;
  pctLabel: string;
  summary: FeeBreakdownSummary | null;
}

interface FeeEntry {
  chargeId: string;
  description: string;
  amount: number;
  status: string;
  isSettlementFee: boolean;
  feeDate?: string | null;
}

interface FeeSplitRow {
  id: string;
  vendorDisplayName: string;
  role: FeeRecipientRole | null;
  percentage: number;
  amount: number;
  isFirm: boolean;
}

/** Outside recipients in the order given (no re-sort by share — that would
 *  reorder a row out from under the user's cursor mid-edit), with the generating
 *  firm's own retained share appended as the final row (BR-010/BR-017) — one
 *  unified list, matching the "Fee Split by Recipient" panel design. */

export default /*@__PURE__*/_defineComponent({
  __name: 'SettlementAttorneyFeeStep',
  props: {
  redesignEnabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  saving: { type: Boolean, default: false },
  recording: { type: Boolean, default: false },
  calculatedFee: { type: Number, default: null },
  existingFeeAmount: { type: Number, default: 0 },
  existingFees: { type: Array as () => FeeEntry[], default: (): FeeEntry[] => [] },
  feeMatchStatus: { type: String as () => 'match' | 'mismatch' | 'none', default: 'none' },
  canConfirm: { type: Boolean, default: false },
  hasNegativeFeeBase: { type: Boolean, default: false },
  feeBreakdown: { type: Object as () => FeeBreakdown, required: true },
  expenseLabel: { type: String, default: 'Expenses' },
  expenseArrangement: { type: String, default: 'Firm' },
  feePercentage: { type: Number, default: 0 },
  roundToNearestDollar: { type: Boolean, default: false },
  selectedChargeId: { type: String, default: null },
  coCounselEnabled: { type: Boolean, default: false },
  feeRecipients: { type: Array as () => FeeRecipient[], default: (): FeeRecipient[] => [] },
  isRecipientsConfirmed: { type: Boolean, default: false },
  isRecipientsLocked: { type: Boolean, default: false },
  noMatterRecipientsConfigured: { type: Boolean, default: false },
  firmName: { type: String, default: 'Your Firm' },
},
  emits: [
  'confirm-fee',
  'go-back',
  'record-fee',
  'rounding-change',
  'manage-fixed-fees',
  'select-fee',
  'load-fee-recipients',
  'update:feeRecipients',
  'confirm-fee-recipients',
  'auto-confirm-fee',
],
  setup(__props, { emit: __emit }) {

function todayIso(): string {
  return format(new Date(), 'yyyy-MM-dd');
}

function toIsoDate(value: string | null | undefined): string {
  if (!value) return todayIso();
  return value.slice(0, 10);
}

function formatFeeDate(value: string | null | undefined): string {
  if (!value) return '';
  const parsed = parseISO(value);
  return isValid(parsed) ? format(parsed, 'MM/dd/yyyy') : value.slice(0, 10);
}

const props = __props;

const emit = __emit;

// ── Redesign state ────────────────────────────────────────
/** Controls visibility of the collapsible calculation breakdown */
const showCalc = ref(false);

/** A 0% contingency fee — not necessarily a formal pro bono designation, just what the notice below describes. */
const isZeroFee = computed(() => (props.feePercentage ?? 0) === 0);

// ── Shared form state ─────────────────────────────────────
const roundingCheckboxModel = computed({
  get: () => props.roundToNearestDollar,
  set: (value: boolean) => emit('rounding-change', value),
});

/**
 * Pre-fill description/date from the existing settlement fee when revisiting
 * the wizard so prior customizations aren't lost. Falls back to defaults.
 */
const existingSettlementFee = computed(() =>
  props.existingFees.find((f) => f.isSettlementFee) ?? null,
);

const feeDescription = ref<string>(
  existingSettlementFee.value?.description || 'Attorney Fee',
);
const feeDate = ref<string>(toIsoDate(existingSettlementFee.value?.feeDate));

// Show the description/date/create row only until a settlement fee exists (old design only).
const showCreateFeeForm = computed(() => !existingSettlementFee.value);

watch(existingSettlementFee, (fee) => {
  if (fee) {
    feeDescription.value = fee.description || 'Attorney Fee';
    feeDate.value = toIsoDate(fee.feeDate);
  }
});

/** Old design: create fee separately then confirm */
function onCreateFee() {
  emit('record-fee', {
    description: feeDescription.value.trim() || 'Attorney Fee',
    feeDate: feeDate.value || todayIso(),
  });
}

/** Redesign: auto-create and confirm in a single action. confirm-fee-recipients
 *  fires first so a parent that syncs it into store state (as ours does) sees
 *  the final recipient set before building the auto-confirm-fee API payload. */
function onAutoConfirm() {
  if (localRecipients.value.length > 0) {
    emit('confirm-fee-recipients', localRecipients.value);
  }
  emit('auto-confirm-fee', {
    description: feeDescription.value.trim() || 'Attorney Fee',
    feeDate: feeDate.value || todayIso(),
  });
}

/** LlDatePicker works in Date objects; we persist as "YYYY-MM-DD" strings. */
const feeDateModel = computed<Date | null>(() => {
  if (!feeDate.value) return null;
  const parsed = parseISO(feeDate.value);
  return isValid(parsed) ? parsed : null;
});

function onFeeDateChange(value: Date | null) {
  feeDate.value = value ? format(value, 'yyyy-MM-dd') : todayIso();
}

/** Amount of the currently selected fee (for mismatch banner in old design). */
const selectedFeeAmount = computed(() => {
  if (!props.selectedChargeId) return 0;
  const fee = props.existingFees.find((f) => f.chargeId === props.selectedChargeId);
  return fee?.amount ?? 0;
});

const grossFeeAmount = computed(() =>
  (props.feeBreakdown.summary?.recoveryAmount ?? 0) * (props.feePercentage ?? 0) / 100,
);

/** Net Attorney Fee (fee minus absorbed expenses) — can go negative when expenses exceed the fee. */
const netAttorneyFeeAmount = computed(
  () => props.feeBreakdown.summary.netAttorneyFee ?? props.feeBreakdown.summary.attorneyFee ?? 0,
);
/** formatCurrency already parenthesizes negatives, so only prepend the minus sign when positive —
 *  otherwise an underwater fee renders as the double-negative "-($X.XX)". */
const netAttorneyFeeDisplay = computed(() =>
  netAttorneyFeeAmount.value < 0
    ? formatCurrency(netAttorneyFeeAmount.value)
    : `−${formatCurrency(netAttorneyFeeAmount.value)}`,
);

// ── Co-Counsel & Referral Fee Recipients (P4.5) ────────────
/** Local editable copy — kept in sync with the prop, but edited independently
 *  so percentage input reactivity doesn't require round-tripping through the
 *  parent on every keystroke. */
const localRecipients = ref<FeeRecipient[]>(props.feeRecipients.map((r) => ({ ...r })));

watch(
  () => props.feeRecipients,
  (recipients) => {
    localRecipients.value = recipients.map((r) => ({ ...r }));
  },
);

/** Percentage inputs stay editable pre-confirm; once locked, "Edit Recipients"
 *  re-enables them (VR-015) without touching isRecipientsLocked itself. */
const recipientsEditable = ref(!props.isRecipientsLocked);
watch(
  () => props.isRecipientsLocked,
  (locked) => {
    recipientsEditable.value = !locked;
  },
);

function onPercentageChange(id: string, value: string | number) {
  const parsed = typeof value === 'number' ? value : parseFloat(value);
  const idx = localRecipients.value.findIndex((r) => r.id === id);
  if (idx === -1) return;
  localRecipients.value[idx] = {
    ...localRecipients.value[idx],
    percentage: Number.isFinite(parsed) ? parsed : 0,
    // The old confirmed dollar amount is stale the instant this row's own percentage
    // is retyped — null it out so recipientShareAmount recomputes live from the new
    // percentage instead of showing a frozen pre-edit amount next to it.
    calculatedShareAmount: null,
  };
  emit('update:feeRecipients', localRecipients.value);
}

const attorneyFeePool = computed(() => props.calculatedFee ?? 0);

/** Each recipient's actual dollar share — the backend's confirmed, FLOOR-rounded
 *  calculatedShareAmount once Step 3 has been confirmed, or a pool×percentage
 *  preview before that (mirrors the per-row amount shown in displayRows).
 *  onPercentageChange nulls out calculatedShareAmount for a row the instant its
 *  own percentage is retyped, so an edited row falls through to the live preview
 *  here while every other still-confirmed row keeps showing its authoritative
 *  backend amount. */
function recipientShareAmount(r: FeeRecipient): number {
  return r.calculatedShareAmount ?? (attorneyFeePool.value * (r.percentage || 0)) / 100;
}

/** Locally-derived preview: BR-010 says the firm retains whatever the FLOOR-rounded
 *  splits leave over, not a clean "100% − sum(percentages)" fraction of the pool —
 *  deriving it from actual per-recipient share amounts (rather than raw percentages)
 *  surfaces that penny-level residual correctly once shares are backend-confirmed.
 *  Math.max guards against a negative preview if percentages are (transiently,
 *  pre-validation) over 100. Used pre-confirm, and as a fallback if the backend
 *  summary hasn't loaded a value yet. */
const derivedRetainedAmount = computed(() =>
  Math.max(
    0,
    attorneyFeePool.value -
      localRecipients.value.reduce((sum, r) => sum + recipientShareAmount(r), 0),
  ),
);
const derivedRetainedPercentage = computed(() =>
  attorneyFeePool.value > 0 ? (derivedRetainedAmount.value / attorneyFeePool.value) * 100 : 0,
);

/** Once recipients are locked (confirmed) AND not currently being re-edited,
 *  summary.generatingFirmRetainedAmount is the backend's authoritative value —
 *  read it directly instead of re-deriving. Otherwise (pre-confirm, or the user
 *  has clicked "Edit Recipients" and is actively typing new percentages) that
 *  same backend field reflects only the matter's last-SAVED percentages, not
 *  whatever the user is currently typing, so the local derivation is used
 *  instead — this is what keeps the firm's row live while editing. */
const retainedAmount = computed(() => {
  const backendValue = props.feeBreakdown.summary?.generatingFirmRetainedAmount;
  return props.isRecipientsLocked && !recipientsEditable.value && backendValue != null
    ? backendValue
    : derivedRetainedAmount.value;
});
const retainedPercentage = computed(() => {
  const backendValue = props.feeBreakdown.summary?.generatingFirmRetainedPercentage;
  return props.isRecipientsLocked && !recipientsEditable.value && backendValue != null
    ? backendValue
    : derivedRetainedPercentage.value;
});

// Defensive coCounselEnabled gate, independent of whether feeRecipients happens to be
// populated — matches this feature's flag-check-everywhere convention (backend, PDF
// renderer, etc.). Both feed the Confirm button's disabled state, so a stale/leftover
// feeRecipients array must never block confirming for a company with the flag off.
/** True when the fee is being split with at least one outside co-counsel/referring
 *  recipient — the "Existing Fee Will Be Updated" mismatch banner compares against
 *  the old single-recipient fee amount, which isn't a meaningful comparison once
 *  the fee is split (BR-mismatch-vs-split). */
const isFeeSplit = computed(
  () => props.coCounselEnabled && localRecipients.value.length > 0,
);

const percentageSumExceeds100 = computed(
  () =>
    props.coCounselEnabled &&
    localRecipients.value.reduce((sum, r) => sum + (r.percentage || 0), 0) > 100,
);
const hasZeroOrNegativePercentage = computed(
  () => props.coCounselEnabled && localRecipients.value.some((r) => (r.percentage ?? 0) <= 0),
);

const displayRows = computed<FeeSplitRow[]>(() => {
  const outside = localRecipients.value
    .map((r) => ({
      id: r.id,
      vendorDisplayName: r.vendorDisplayName,
      role: r.role,
      percentage: r.percentage,
      // Prefer the backend's confirmed, FLOOR-rounded share once Step 3 has
      // actually been confirmed — a client-side pool×percentage recalculation
      // is only a preview and can diverge by a cent from the real value.
      amount: recipientShareAmount(r),
      isFirm: false,
    }));
  const firmRow: FeeSplitRow = {
    id: '__firm__',
    vendorDisplayName: props.firmName,
    role: null,
    percentage: retainedPercentage.value,
    amount: retainedAmount.value,
    isFirm: true,
  };
  return [...outside, firmRow];
});

/** Deliberately does NOT gate on noMatterRecipientsConfigured — that flag can be
 *  stale-true from an earlier empty fetch (e.g. a recipient was since added via
 *  the Fee Recipients tab), and a stale "already checked, found nothing" shouldn't
 *  permanently block re-fetching. Reactive (not onMounted-only) so a later prop
 *  change that makes this true again — e.g. feeRecipients going back to empty —
 *  triggers another attempt, not just the first render. */
const shouldLoadFeeRecipients = computed(
  () => props.coCounselEnabled && props.feeRecipients.length === 0 && !props.isRecipientsConfirmed,
);
watch(
  shouldLoadFeeRecipients,
  (should) => {
    if (should) emit('load-fee-recipients');
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    flat: "",
    class: "border-0 !bg-[rgb(var(--v-theme-surface))]"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "d-flex align-center gap-1" }, {
        default: _withCtx(() => [
          _cache[11] || (_cache[11] = _createTextVNode(" Step 3: Record Attorney Fee ", -1)),
          (__props.redesignEnabled)
            ? (_openBlock(), _createBlock(LlTooltip, {
                key: 0,
                "max-width": "260",
                text: "The fee is calculated automatically. Confirm to record it — expand below to edit the description, date, or rounding."
              }, {
                activator: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    size: "16",
                    color: "grey",
                    class: "cursor-pointer"
                  }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-information-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (__props.loading)
            ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 0,
                type: "paragraph, paragraph",
                class: "mb-4"
              }))
            : _createCommentVNode("", true),
          (!__props.redesignEnabled && !__props.loading)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (__props.feeMatchStatus === 'mismatch')
                  ? (_openBlock(), _createBlock(AlertBar, {
                      key: 0,
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => [
                        _cache[15] || (_cache[15] = _createElementVNode("strong", null, "Selected Fee Will Be Updated", -1)),
                        _createElementVNode("p", _hoisted_1, [
                          _cache[12] || (_cache[12] = _createTextVNode(" The selected fee of ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatCurrency)(selectedFeeAmount.value)), 1),
                          _cache[13] || (_cache[13] = _createTextVNode(" will be updated to ", -1)),
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatCurrency)(__props.calculatedFee ?? 0)), 1),
                          _cache[14] || (_cache[14] = _createTextVNode(" when you confirm below. ", -1))
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_2, [
                  (__props.feeBreakdown.variant === 'gross')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[16] || (_cache[16] = _createTextVNode(" Using the ", -1)),
                        _cache[17] || (_cache[17] = _createElementVNode("strong", null, "Gross", -1)),
                        _cache[18] || (_cache[18] = _createTextVNode(" method, the fee is calculated on the full settlement amount. Only ", -1)),
                        _cache[19] || (_cache[19] = _createElementVNode("strong", null, "unreimbursed costs", -1)),
                        _cache[20] || (_cache[20] = _createTextVNode(" are deducted from the client's share. ", -1))
                      ], 64))
                    : (__props.feeBreakdown.variant === 'net')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _cache[21] || (_cache[21] = _createTextVNode(" Using the ", -1)),
                          _cache[22] || (_cache[22] = _createElementVNode("strong", null, "Net", -1)),
                          _cache[23] || (_cache[23] = _createTextVNode(" method, ", -1)),
                          _createElementVNode("strong", null, "total " + _toDisplayString(__props.expenseLabel), 1),
                          _cache[24] || (_cache[24] = _createTextVNode(" are deducted first, then the fee is calculated on the remaining amount. ", -1))
                        ], 64))
                      : (__props.feeBreakdown.variant === 'absorbed-gross')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _cache[25] || (_cache[25] = _createTextVNode(" The firm ", -1)),
                            _cache[26] || (_cache[26] = _createElementVNode("strong", null, "absorbs all expenses", -1)),
                            _cache[27] || (_cache[27] = _createTextVNode(" from the fee. Using the ", -1)),
                            _cache[28] || (_cache[28] = _createElementVNode("strong", null, "Gross", -1)),
                            _cache[29] || (_cache[29] = _createTextVNode(" method, the fee is calculated on the full settlement, then expenses are deducted from it. The client pays no costs. ", -1))
                          ], 64))
                        : (__props.feeBreakdown.variant === 'absorbed-net')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _cache[30] || (_cache[30] = _createTextVNode(" The firm ", -1)),
                              _cache[31] || (_cache[31] = _createElementVNode("strong", null, "absorbs all expenses", -1)),
                              _cache[32] || (_cache[32] = _createTextVNode(". Using the ", -1)),
                              _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Net", -1)),
                              _cache[34] || (_cache[34] = _createTextVNode(" method, expenses reduce the fee base — the fee is calculated on the remaining amount. The client pays no costs. ", -1))
                            ], 64))
                          : _createCommentVNode("", true)
                ]),
                (__props.feeBreakdown.summary)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (__props.feeBreakdown.variant === 'gross')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("div", _hoisted_4, [
                              _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", _hoisted_7, "Attorney Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                              _createElementVNode("span", _hoisted_8, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("span", _hoisted_10, [
                                _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                (__props.roundToNearestDollar)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, " - rounded to the nearest dollar"))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("span", _hoisted_13, "Less: " + _toDisplayString(__props.expenseLabel), 1),
                              _createElementVNode("span", _hoisted_14, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                            ]),
                            _createVNode(_component_v_divider, { class: "my-1 mx-2 border-2 border-gray-700" }),
                            _createElementVNode("div", _hoisted_15, [
                              _cache[36] || (_cache[36] = _createElementVNode("span", { class: "text-body-1 font-weight-bold" }, "Attorney Fee to Record", -1)),
                              _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _cache[37] || (_cache[37] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                              _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                            ])
                          ], 64))
                        : (__props.feeBreakdown.variant === 'net')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_19, [
                                _cache[38] || (_cache[38] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, "Less: " + _toDisplayString(__props.expenseLabel), 1),
                                _createElementVNode("span", _hoisted_23, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_24, [
                                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-body-2" }, "Net for Fee Calculation", -1)),
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, "Attorney Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                _createElementVNode("span", _hoisted_28, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_29, [
                                _createElementVNode("span", _hoisted_30, [
                                  _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                  (__props.roundToNearestDollar)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, " - rounded to the nearest dollar"))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _createVNode(_component_v_divider, { class: "my-1 mx-2 border-2 border-gray-700" }),
                              _createElementVNode("div", _hoisted_32, [
                                _cache[40] || (_cache[40] = _createElementVNode("span", { class: "text-body-1 font-weight-bold" }, "Attorney Fee to Record", -1)),
                                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                              ])
                            ], 64))
                          : (__props.feeBreakdown.variant === 'absorbed-gross')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createElementVNode("div", _hoisted_36, [
                                  _cache[42] || (_cache[42] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, "Gross Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                  _createElementVNode("span", _hoisted_40, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? grossFeeAmount.value)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("span", _hoisted_42, [
                                    _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                    (__props.roundToNearestDollar)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, " - rounded to the nearest dollar"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                  _cache[43] || (_cache[43] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Less: Firm Expenses (absorbed)", -1)),
                                  _createElementVNode("span", _hoisted_45, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_46, [
                                  _cache[44] || (_cache[44] = _createElementVNode("span", { class: "text-body-2" }, "Net Attorney Fee", -1)),
                                  _createElementVNode("span", _hoisted_47, _toDisplayString(netAttorneyFeeDisplay.value), 1)
                                ]),
                                _cache[47] || (_cache[47] = _createElementVNode("div", { class: "px-2 py-0" }, [
                                  _createElementVNode("span", { class: "text-caption text-grey font-italic" }, "Expenses come out of the fee - the client is not charged")
                                ], -1)),
                                _createVNode(_component_v_divider, { class: "my-1 mx-2 border-2 border-gray-700" }),
                                _createElementVNode("div", _hoisted_48, [
                                  _cache[45] || (_cache[45] = _createElementVNode("span", { class: "text-body-1 font-weight-bold" }, "Attorney Fee to Record", -1)),
                                  _createElementVNode("span", _hoisted_49, _toDisplayString(_unref(formatCurrency)(netAttorneyFeeAmount.value)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _cache[46] || (_cache[46] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                  _createElementVNode("span", _hoisted_51, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                                ])
                              ], 64))
                            : (__props.feeBreakdown.variant === 'absorbed-net')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _createElementVNode("div", _hoisted_52, [
                                    _cache[48] || (_cache[48] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                    _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _cache[49] || (_cache[49] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Less: Firm Expenses (absorbed)", -1)),
                                    _createElementVNode("span", _hoisted_55, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_56, [
                                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "text-body-2" }, "Net for Fee Calculation", -1)),
                                    _createElementVNode("span", _hoisted_57, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("span", _hoisted_59, "Attorney Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                    _createElementVNode("span", _hoisted_60, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_61, [
                                    _createElementVNode("span", _hoisted_62, [
                                      _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                      (__props.roundToNearestDollar)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_63, " - rounded to the nearest dollar"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_64, [
                                    _cache[51] || (_cache[51] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Less: Total Case Costs (Absorbed)", -1)),
                                    _createElementVNode("span", _hoisted_65, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_66, [
                                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-body-2" }, "Net Attorney Fee", -1)),
                                    _createElementVNode("span", _hoisted_67, _toDisplayString(netAttorneyFeeDisplay.value), 1)
                                  ]),
                                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "px-2 py-1" }, [
                                    _createElementVNode("span", { class: "text-caption text-green-darken-2 font-italic" }, "Firm absorbs expenses - costs reduce the fee base and come out of the fee. The client is not charged.")
                                  ], -1)),
                                  _createVNode(_component_v_divider, { class: "my-1 mx-2 border-2 border-gray-700" }),
                                  _createElementVNode("div", _hoisted_68, [
                                    _cache[53] || (_cache[53] = _createElementVNode("span", { class: "text-body-1 font-weight-bold" }, "Attorney Fee to Record", -1)),
                                    _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(formatCurrency)(netAttorneyFeeAmount.value)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_70, [
                                    _cache[54] || (_cache[54] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                    _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                                  ])
                                ], 64))
                              : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("div", null, [
                      _cache[56] || (_cache[56] = _createElementVNode("div", { class: "text-uppercase text-caption font-weight-bold text-grey-darken-1 mb-1" }, "Attorney Fee to Record", -1)),
                      _createElementVNode("div", _hoisted_74, _toDisplayString(_unref(formatCurrency)(__props.calculatedFee ?? 0)), 1)
                    ]),
                    _createElementVNode("div", null, [
                      (__props.feeMatchStatus === 'match')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createVNode(LlIcon, {
                              icon: "mdi-check",
                              size: "small",
                              color: "success",
                              class: "mr-1"
                            }),
                            _cache[57] || (_cache[57] = _createTextVNode("Fee matches ", -1))
                          ]))
                        : (__props.feeMatchStatus === 'mismatch')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "orange-darken-2",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                  _createTextVNode("mdi-alert", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[59] || (_cache[59] = _createTextVNode("Fee mismatch ", -1))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                              _createVNode(_component_v_icon, {
                                size: "small",
                                color: "amber-darken-2",
                                class: "mr-1"
                              }, {
                                default: _withCtx(() => [...(_cache[60] || (_cache[60] = [
                                  _createTextVNode("mdi-alert-outline", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[61] || (_cache[61] = _createTextVNode("No matching fee ", -1))
                            ]))
                    ])
                  ]),
                  _createVNode(LlCheckbox, {
                    modelValue: roundingCheckboxModel.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((roundingCheckboxModel).value = $event)),
                    label: "Round to whole dollar",
                    "hide-details": "",
                    class: "ma-0 pa-0"
                  }, null, 8, ["modelValue"])
                ]),
                (showCreateFeeForm.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                      _createElementVNode("div", _hoisted_79, [
                        _createElementVNode("div", _hoisted_80, [
                          _cache[64] || (_cache[64] = _createTextVNode(" Fee Description ", -1)),
                          _createVNode(_component_v_tooltip, {
                            location: "top",
                            "max-width": "280"
                          }, {
                            activator: _withCtx(({ props: tooltipProps }) => [
                              _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                                size: "14",
                                color: "grey"
                              }), {
                                default: _withCtx(() => [...(_cache[62] || (_cache[62] = [
                                  _createTextVNode("mdi-information-outline", -1)
                                ]))]),
                                _: 1
                              }, 16)
                            ]),
                            default: _withCtx(() => [
                              _cache[63] || (_cache[63] = _createTextVNode(" This description appears on the fixed fee record and the settlement invoice. Max 255 characters. ", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(LlTextField, {
                          modelValue: feeDescription.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((feeDescription).value = $event)),
                          maxlength: 255,
                          density: "compact",
                          "hide-details": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _cache[67] || (_cache[67] = _createTextVNode(" Fee Date ", -1)),
                          _createVNode(_component_v_tooltip, {
                            location: "top",
                            "max-width": "280"
                          }, {
                            activator: _withCtx(({ props: tooltipProps }) => [
                              _createVNode(_component_v_icon, _mergeProps(tooltipProps, {
                                size: "14",
                                color: "grey"
                              }), {
                                default: _withCtx(() => [...(_cache[65] || (_cache[65] = [
                                  _createTextVNode("mdi-information-outline", -1)
                                ]))]),
                                _: 1
                              }, 16)
                            ]),
                            default: _withCtx(() => [
                              _cache[66] || (_cache[66] = _createTextVNode(" The date the fee is recorded. You can change this to match the settlement date or fee agreement date. ", -1))
                            ]),
                            _: 1
                          })
                        ]),
                        _createVNode(LlDatePicker, {
                          class: "fee-date-picker",
                          "model-value": feeDateModel.value,
                          label: "",
                          "label-class": "d-none",
                          "onUpdate:modelValue": onFeeDateChange
                        }, null, 8, ["model-value"])
                      ]),
                      (__props.feeMatchStatus === 'none')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createVNode(LlSecondaryButton, {
                              color: "primary",
                              variant: "outlined",
                              loading: __props.recording,
                              disabled: !feeDescription.value.trim(),
                              onClick: onCreateFee
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" + Create Attorney Fee ( " + _toDisplayString(_unref(formatCurrency)(__props.calculatedFee ?? 0)) + " ) ", 1)
                              ]),
                              _: 1
                            }, 8, ["loading", "disabled"]),
                            _createElementVNode("a", {
                              class: "text-primary hover:!text-[rgb(var(--v-theme-primary-darken-1))] hover:underline text-body-2 font-weight-medium cursor-pointer",
                              style: {"white-space":"nowrap"},
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('manage-fixed-fees')))
                            }, " manage fees → ")
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_84, [
                  (__props.existingFees.length > 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[70] || (_cache[70] = _createElementVNode("div", { class: "text-uppercase text-caption font-weight-bold text-grey-darken-1 mb-2" }, "Fixed Fees on This Matter", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.existingFees, (fee) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: fee.chargeId,
                            class: _normalizeClass(["border rounded-lg pa-3 mb-2 flex justify-between items-center cursor-pointer hover:bg-grey-lighten-4 transition-colors", fee.chargeId === __props.selectedChargeId ? 'border-green bg-green-lighten-5' : '']),
                            onClick: ($event: any) => (_ctx.$emit('select-fee', fee.chargeId))
                          }, [
                            _createElementVNode("div", _hoisted_86, [
                              (fee.chargeId === __props.selectedChargeId)
                                ? (_openBlock(), _createBlock(LlIcon, {
                                    key: 0,
                                    icon: "mdi-radiobox-marked",
                                    color: "primary",
                                    size: "small"
                                  }))
                                : (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    color: "grey",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [...(_cache[68] || (_cache[68] = [
                                      _createTextVNode("mdi-radiobox-blank", -1)
                                    ]))]),
                                    _: 1
                                  })),
                              _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_87, _toDisplayString(fee.description), 1),
                                _createElementVNode("div", _hoisted_88, [
                                  _cache[69] || (_cache[69] = _createTextVNode(" Fixed Fee ", -1)),
                                  (fee.feeDate)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString(formatFeeDate(fee.feeDate)), 1)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" · " + _toDisplayString(fee.status), 1)
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_89, _toDisplayString(_unref(formatCurrency)(fee.amount)), 1)
                          ], 10, _hoisted_85))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_90, " No fixed fees found. Create one to proceed. "))
                ]),
                _createVNode(AlertBar, {
                  type: "info",
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [...(_cache[71] || (_cache[71] = [
                    _createTextVNode(" Select or create exactly one fixed fee matching the calculated attorney fee. This fee will appear on the settlement statement and invoice. ", -1)
                  ]))]),
                  _: 1
                })
              ], 64))
            : (__props.redesignEnabled && !__props.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  (__props.coCounselEnabled && __props.noMatterRecipientsConfigured && localRecipients.value.length === 0)
                    ? (_openBlock(), _createBlock(AlertBar, {
                        key: 0,
                        type: "info",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [...(_cache[72] || (_cache[72] = [
                          _createTextVNode(" No fee recipients configured. Add recipients in the Fee Recipients tab before this step. ", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (__props.feeMatchStatus === 'mismatch' && !isFeeSplit.value)
                    ? (_openBlock(), _createBlock(AlertBar, {
                        key: 1,
                        class: "mb-3"
                      }, {
                        default: _withCtx(() => [
                          _cache[76] || (_cache[76] = _createElementVNode("strong", null, "Existing Fee Will Be Updated", -1)),
                          _createElementVNode("p", _hoisted_91, [
                            _cache[73] || (_cache[73] = _createTextVNode(" A fee of ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_unref(formatCurrency)(__props.existingFeeAmount)), 1),
                            _cache[74] || (_cache[74] = _createTextVNode(" already exists on this matter. It will be updated to ", -1)),
                            _createElementVNode("strong", null, _toDisplayString(_unref(formatCurrency)(__props.calculatedFee ?? 0)), 1),
                            _cache[75] || (_cache[75] = _createTextVNode(" when you confirm below. ", -1))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (isZeroFee.value)
                    ? (_openBlock(), _createBlock(AlertBar, {
                        key: 2,
                        type: "info",
                        class: "mb-3"
                      }, {
                        default: _withCtx(() => [...(_cache[77] || (_cache[77] = [
                          _createElementVNode("strong", null, "Pro Bono Case", -1),
                          _createElementVNode("p", { class: "mt-1 mb-0" }, "A 0% fee means no attorney fee will be charged. The statement will generate with a $0.00 fee line.", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (__props.hasNegativeFeeBase)
                    ? (_openBlock(), _createBlock(AlertBar, {
                        key: 3,
                        type: "error",
                        class: "mb-4"
                      }, {
                        default: _withCtx(() => [...(_cache[78] || (_cache[78] = [
                          _createElementVNode("strong", null, "Expenses Exceed Recovery", -1),
                          _createElementVNode("p", { class: "mt-1 mb-0" }, "Total expenses exceed the recovery amount. With the net-of-expenses calculation method, the fee base would be negative. You cannot proceed until expenses are reduced or the recovery amount is increased.", -1)
                        ]))]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_92, [
                    _createElementVNode("div", null, [
                      _cache[79] || (_cache[79] = _createElementVNode("div", { class: "text-[10px] font-semibold text-[#747474] uppercase tracking-wider mb-[5px]" }, "Attorney Fee", -1)),
                      _createElementVNode("div", _hoisted_93, _toDisplayString(__props.calculatedFee == null ? '—' : _unref(formatCurrency)(__props.calculatedFee)), 1)
                    ]),
                    _createVNode(LlSecondaryButton, {
                      size: "small",
                      variant: "outlined",
                      "prepend-icon": showCalc.value ? 'mdi-chevron-up' : 'mdi-chevron-down',
                      class: "!bg-[rgb(var(--v-theme-surface))]",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (showCalc.value = !showCalc.value))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(showCalc.value ? 'Hide calculation' : 'Show calculation'), 1)
                      ]),
                      _: 1
                    }, 8, ["prepend-icon"])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_94, [
                    _createElementVNode("p", _hoisted_95, [
                      (__props.feeBreakdown.variant === 'gross')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[80] || (_cache[80] = _createTextVNode(" Using the ", -1)),
                            _cache[81] || (_cache[81] = _createElementVNode("strong", null, "Gross", -1)),
                            _cache[82] || (_cache[82] = _createTextVNode(" method, the fee is calculated on the full settlement amount. Only ", -1)),
                            _cache[83] || (_cache[83] = _createElementVNode("strong", null, "unreimbursed costs", -1)),
                            _cache[84] || (_cache[84] = _createTextVNode(" are deducted from the client's share. ", -1))
                          ], 64))
                        : (__props.feeBreakdown.variant === 'net')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _cache[85] || (_cache[85] = _createTextVNode(" Using the ", -1)),
                              _cache[86] || (_cache[86] = _createElementVNode("strong", null, "Net", -1)),
                              _cache[87] || (_cache[87] = _createTextVNode(" method, ", -1)),
                              _createElementVNode("strong", null, "total " + _toDisplayString(__props.expenseLabel), 1),
                              _cache[88] || (_cache[88] = _createTextVNode(" are deducted first, then the fee is calculated on the remaining amount. ", -1))
                            ], 64))
                          : (__props.feeBreakdown.variant === 'absorbed-gross')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _cache[89] || (_cache[89] = _createTextVNode(" The firm ", -1)),
                                _cache[90] || (_cache[90] = _createElementVNode("strong", null, "absorbs all expenses", -1)),
                                _cache[91] || (_cache[91] = _createTextVNode(" from the fee. Using the ", -1)),
                                _cache[92] || (_cache[92] = _createElementVNode("strong", null, "Gross", -1)),
                                _cache[93] || (_cache[93] = _createTextVNode(" method, the fee is calculated on the full settlement, then expenses are deducted from it. The client pays no costs. ", -1))
                              ], 64))
                            : (__props.feeBreakdown.variant === 'absorbed-net')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                  _cache[94] || (_cache[94] = _createTextVNode(" The firm ", -1)),
                                  _cache[95] || (_cache[95] = _createElementVNode("strong", null, "absorbs all expenses", -1)),
                                  _cache[96] || (_cache[96] = _createTextVNode(". Using the ", -1)),
                                  _cache[97] || (_cache[97] = _createElementVNode("strong", null, "Net", -1)),
                                  _cache[98] || (_cache[98] = _createTextVNode(" method, expenses reduce the fee base — the fee is calculated on the remaining amount. The client pays no costs. ", -1))
                                ], 64))
                              : _createCommentVNode("", true)
                    ]),
                    (__props.feeBreakdown.summary)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                          (__props.feeBreakdown.variant === 'gross')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_97, [
                                  _cache[99] || (_cache[99] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                  _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_99, [
                                  _createElementVNode("span", _hoisted_100, "Attorney Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                  _createElementVNode("span", _hoisted_101, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_102, [
                                  _createElementVNode("span", _hoisted_103, [
                                    _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                    (__props.roundToNearestDollar)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_104, " - rounded to the nearest dollar"))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_105, [
                                  _createElementVNode("span", _hoisted_106, "Less: " + _toDisplayString(__props.expenseLabel), 1),
                                  _createElementVNode("span", _hoisted_107, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_108, [
                                  _cache[100] || (_cache[100] = _createElementVNode("span", { class: "text-[#555]" }, "Attorney Fee to Record", -1)),
                                  _createElementVNode("span", _hoisted_109, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                                ]),
                                _createElementVNode("div", _hoisted_110, [
                                  _cache[101] || (_cache[101] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                  _createElementVNode("span", _hoisted_111, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                                ])
                              ], 64))
                            : (__props.feeBreakdown.variant === 'net')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createElementVNode("div", _hoisted_112, [
                                    _cache[102] || (_cache[102] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                    _createElementVNode("span", _hoisted_113, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_114, [
                                    _createElementVNode("span", _hoisted_115, "Less: " + _toDisplayString(__props.expenseLabel), 1),
                                    _createElementVNode("span", _hoisted_116, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_117, [
                                    _cache[103] || (_cache[103] = _createElementVNode("span", { class: "text-body-2 font-weight-bold" }, "Net for Fee Calculation", -1)),
                                    _createElementVNode("span", _hoisted_118, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_119, [
                                    _createElementVNode("span", _hoisted_120, "Attorney Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                    _createElementVNode("span", _hoisted_121, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_122, [
                                    _createElementVNode("span", _hoisted_123, [
                                      _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                      (__props.roundToNearestDollar)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_124, " - rounded to the nearest dollar"))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_125, [
                                    _cache[104] || (_cache[104] = _createElementVNode("span", { class: "text-[#555]" }, "Attorney Fee to Record", -1)),
                                    _createElementVNode("span", _hoisted_126, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_127, [
                                    _cache[105] || (_cache[105] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                    _createElementVNode("span", _hoisted_128, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                                  ])
                                ], 64))
                              : (__props.feeBreakdown.variant === 'absorbed-gross')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("div", _hoisted_129, [
                                      _cache[106] || (_cache[106] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                      _createElementVNode("span", _hoisted_130, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_131, [
                                      _createElementVNode("span", _hoisted_132, "Gross Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                      _createElementVNode("span", _hoisted_133, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? grossFeeAmount.value)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_134, [
                                      _createElementVNode("span", _hoisted_135, [
                                        _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                        (__props.roundToNearestDollar)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_136, " - rounded to the nearest dollar"))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_137, [
                                      _cache[107] || (_cache[107] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Less: Firm Expenses (absorbed)", -1)),
                                      _createElementVNode("span", _hoisted_138, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_139, [
                                      _cache[108] || (_cache[108] = _createElementVNode("span", { class: "text-body-2 font-weight-bold" }, "Net Attorney Fee", -1)),
                                      _createElementVNode("span", _hoisted_140, _toDisplayString(netAttorneyFeeDisplay.value), 1)
                                    ]),
                                    _cache[111] || (_cache[111] = _createElementVNode("div", { class: "px-2 pb-1" }, [
                                      _createElementVNode("span", { class: "text-caption text-grey font-italic" }, "Expenses come out of the fee - the client is not charged")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_141, [
                                      _cache[109] || (_cache[109] = _createElementVNode("span", { class: "text-[#555]" }, "Attorney Fee to Record", -1)),
                                      _createElementVNode("span", _hoisted_142, _toDisplayString(_unref(formatCurrency)(netAttorneyFeeAmount.value)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_143, [
                                      _cache[110] || (_cache[110] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                      _createElementVNode("span", _hoisted_144, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                                    ])
                                  ], 64))
                                : (__props.feeBreakdown.variant === 'absorbed-net')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                      _createElementVNode("div", _hoisted_145, [
                                        _cache[112] || (_cache[112] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Recovery Amount", -1)),
                                        _createElementVNode("span", _hoisted_146, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.recoveryAmount ?? 0)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_147, [
                                        _cache[113] || (_cache[113] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Less: Firm Expenses (absorbed)", -1)),
                                        _createElementVNode("span", _hoisted_148, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_149, [
                                        _cache[114] || (_cache[114] = _createElementVNode("span", { class: "text-body-2 font-weight-bold" }, "Net for Fee Calculation", -1)),
                                        _createElementVNode("span", _hoisted_150, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_151, [
                                        _createElementVNode("span", _hoisted_152, "Attorney Fee (" + _toDisplayString(__props.feeBreakdown.pctLabel) + ")", 1),
                                        _createElementVNode("span", _hoisted_153, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.attorneyFee ?? 0)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_154, [
                                        _createElementVNode("span", _hoisted_155, [
                                          _createTextVNode("Fee = " + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.feeBase ?? 0)) + " × " + _toDisplayString(__props.feeBreakdown.pctLabel), 1),
                                          (__props.roundToNearestDollar)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_156, " - rounded to the nearest dollar"))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_157, [
                                        _cache[115] || (_cache[115] = _createElementVNode("span", { class: "text-body-2 text-grey-darken-2" }, "Less: Total Case Costs (Absorbed)", -1)),
                                        _createElementVNode("span", _hoisted_158, "−" + _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.totalExpenses ?? 0)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_159, [
                                        _cache[116] || (_cache[116] = _createElementVNode("span", { class: "text-body-2 font-weight-bold" }, "Net Attorney Fee", -1)),
                                        _createElementVNode("span", _hoisted_160, _toDisplayString(netAttorneyFeeDisplay.value), 1)
                                      ]),
                                      _cache[119] || (_cache[119] = _createElementVNode("div", { class: "px-2 pb-1" }, [
                                        _createElementVNode("span", { class: "text-caption text-green-darken-2 font-italic" }, "Firm absorbs expenses - costs reduce the fee base and come out of the fee. The client is not charged.")
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_161, [
                                        _cache[117] || (_cache[117] = _createElementVNode("span", { class: "text-[#555]" }, "Attorney Fee to Record", -1)),
                                        _createElementVNode("span", _hoisted_162, _toDisplayString(_unref(formatCurrency)(netAttorneyFeeAmount.value)), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_163, [
                                        _cache[118] || (_cache[118] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Client Net from Settlement", -1)),
                                        _createElementVNode("span", _hoisted_164, _toDisplayString(_unref(formatCurrency)(__props.feeBreakdown.summary.clientNetRecovery ?? 0)), 1)
                                      ])
                                    ], 64))
                                  : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 512), [
                    [_vShow, showCalc.value]
                  ]),
                  _createElementVNode("details", _hoisted_165, [
                    _cache[124] || (_cache[124] = _createElementVNode("summary", { class: "flex items-center gap-[5px] text-[12.5px] font-semibold text-[#555] cursor-pointer select-none list-none py-[5px]" }, [
                      _createElementVNode("svg", {
                        viewBox: "0 0 24 24",
                        width: "13",
                        height: "13",
                        fill: "none",
                        stroke: "currentColor",
                        "stroke-width": "2.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      }, [
                        _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                      ]),
                      _createTextVNode(" Edit fee details ")
                    ], -1)),
                    _createElementVNode("div", _hoisted_166, [
                      _createElementVNode("div", _hoisted_167, [
                        _createElementVNode("div", _hoisted_168, [
                          _createElementVNode("div", _hoisted_169, [
                            _cache[121] || (_cache[121] = _createTextVNode(" Fee Description ", -1)),
                            _createVNode(LlTooltip, {
                              "max-width": "260",
                              text: "Appears on the fixed fee record and the settlement invoice. Max 255 characters."
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  color: "grey",
                                  class: "cursor-pointer"
                                }, {
                                  default: _withCtx(() => [...(_cache[120] || (_cache[120] = [
                                    _createTextVNode("mdi-information-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(LlTextField, {
                            modelValue: feeDescription.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((feeDescription).value = $event)),
                            maxlength: 255,
                            density: "compact",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_170, [
                          _createElementVNode("div", _hoisted_171, [
                            _cache[123] || (_cache[123] = _createTextVNode(" Fee Date ", -1)),
                            _createVNode(LlTooltip, {
                              "max-width": "260",
                              text: "The date the fee is recorded. Defaults to today — change to match the settlement or fee agreement date."
                            }, {
                              activator: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "14",
                                  color: "grey",
                                  class: "cursor-pointer"
                                }, {
                                  default: _withCtx(() => [...(_cache[122] || (_cache[122] = [
                                    _createTextVNode("mdi-information-outline", -1)
                                  ]))]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _createVNode(LlDatePicker, {
                            class: "fee-date-picker",
                            "model-value": feeDateModel.value,
                            label: "",
                            "label-class": "d-none",
                            "onUpdate:modelValue": onFeeDateChange
                          }, null, 8, ["model-value"])
                        ]),
                        _createElementVNode("div", _hoisted_172, [
                          _createVNode(LlCheckbox, {
                            modelValue: roundingCheckboxModel.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((roundingCheckboxModel).value = $event)),
                            label: "Round to whole dollar",
                            "hide-details": "",
                            class: "ma-0 pa-0"
                          }, null, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  (__props.coCounselEnabled && localRecipients.value.length > 0)
                    ? (_openBlock(), _createElementBlock("details", _hoisted_173, [
                        _createElementVNode("summary", _hoisted_174, [
                          _cache[125] || (_cache[125] = _createElementVNode("svg", {
                            viewBox: "0 0 24 24",
                            width: "13",
                            height: "13",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("path", { d: "M6 9l6 6 6-6" })
                          ], -1)),
                          _createTextVNode(" Fee Split by Recipient (" + _toDisplayString(displayRows.value.length) + " recipients) ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_175, [
                          (percentageSumExceeds100.value)
                            ? (_openBlock(), _createBlock(AlertBar, {
                                key: 0,
                                type: "error",
                                class: "mb-2"
                              }, {
                                default: _withCtx(() => [...(_cache[126] || (_cache[126] = [
                                  _createTextVNode(" Percentages cannot exceed 100% ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (hasZeroOrNegativePercentage.value)
                            ? (_openBlock(), _createBlock(AlertBar, {
                                key: 1,
                                type: "error",
                                class: "mb-2"
                              }, {
                                default: _withCtx(() => [...(_cache[127] || (_cache[127] = [
                                  _createTextVNode(" Each recipient's percentage must be greater than 0 ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayRows.value, (row) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: row.id,
                              class: _normalizeClass(["fee-recipient-row flex items-center justify-between gap-3 py-[6px]", row.isFirm
                ? 'fee-recipient-row--firm font-weight-bold text-[#1b5e20]'
                : 'border-b border-b-[#d7ebda]'])
                            }, [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(row.vendorDisplayName), 1),
                                (!row.isFirm)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_176, "(" + _toDisplayString(_unref(roleLabel)(row.role)) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_177, [
                                (!row.isFirm && recipientsEditable.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                      _createVNode(LlTextField, {
                                        class: "fee-recipient-percentage-input",
                                        "model-value": row.percentage,
                                        type: "number",
                                        density: "compact",
                                        "hide-details": "",
                                        suffix: "%",
                                        "onUpdate:modelValue": (value) => onPercentageChange(row.id, value)
                                      }, null, 8, ["model-value", "onUpdate:modelValue"])
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_179, _toDisplayString(row.percentage.toFixed(4)) + "%", 1)),
                                _createElementVNode("span", _hoisted_180, _toDisplayString(_unref(formatCurrency)(row.amount)), 1)
                              ])
                            ], 2))
                          }), 128)),
                          (__props.isRecipientsLocked && !recipientsEditable.value)
                            ? (_openBlock(), _createBlock(LlSecondaryButton, {
                                key: 2,
                                variant: "text",
                                color: "primary",
                                size: "small",
                                class: "edit-recipients-link hover:!text-[rgb(var(--v-theme-primary-darken-1))] hover:underline font-weight-medium d-inline-block mt-2 px-0",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (recipientsEditable.value = true))
                              }, {
                                default: _withCtx(() => [...(_cache[128] || (_cache[128] = [
                                  _createTextVNode(" Edit Recipients ", -1)
                                ]))]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
          (!__props.redesignEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_181, [
                _createVNode(LlSecondaryButton, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('go-back')))
                }, {
                  default: _withCtx(() => [...(_cache[129] || (_cache[129] = [
                    _createTextVNode(" ← Back ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(LlSecondaryButton, {
                  color: "primary",
                  disabled: !__props.canConfirm,
                  loading: __props.saving,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('confirm-fee')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Confirm Attorney Fee (" + _toDisplayString(_unref(formatCurrency)(__props.calculatedFee ?? 0)) + ") → ", 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_182, [
                _createVNode(LlSecondaryButton, {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('go-back')))
                }, {
                  default: _withCtx(() => [...(_cache[130] || (_cache[130] = [
                    _createTextVNode(" ← Back ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(LlSecondaryButton, {
                  color: "primary",
                  disabled: __props.hasNegativeFeeBase || __props.loading || __props.calculatedFee == null || percentageSumExceeds100.value,
                  loading: __props.recording || __props.saving,
                  onClick: onAutoConfirm
                }, {
                  default: _withCtx(() => [...(_cache[131] || (_cache[131] = [
                    _createTextVNode(" Confirm Attorney Fee → ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})